import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden" data-id="element-130">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-primary/10 rounded-full blur-[120px] pointer-events-none" data-id="element-131" />

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-133">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-primary/20 text-brand-accent text-sm font-bold tracking-wide border border-brand-primary/30 mb-8" data-id="element-134">
            🌿 MAMÁ SIN CAOS®
          </span>
        </motion.div>

        <motion.h1 className="text-5xl md:text-7xl lg:text-8xl font-serif text-brand-cream-light leading-tight mb-4" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-135">
          Tu lactancia sin dolor.
          <br data-id="element-136" />
          <span className="text-brand-accent" data-id="element-137">Lista. Desde hoy.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-8 mb-12" data-id="element-138">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-cream mb-2" data-id="element-139">
            S.O.S. Lactancia — El Pack Completo
          </h2>
          <p className="text-lg md:text-xl text-brand-primary" data-id="element-140">
            El sistema N°1 para mamás primerizas en Argentina
          </p>
          <p className="text-xl md:text-2xl font-serif text-brand-gold mt-4 italic" data-id="element-141">
            Del primer enganche al destete — Todo resuelto.
          </p>
        </motion.div>

        <motion.div className="flex flex-wrap justify-center gap-3 mb-12" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-142">
          {['📄 100% PDF', '⚡ Acceso en 5 min', '🇦🇷 Para Argentina', '🍼 0 al destete'].map((pill, i) => <span key={i} className="px-4 py-2 rounded-lg bg-brand-darker border border-brand-primary/20 text-brand-cream text-sm md:text-base font-medium shadow-lg" data-id="element-143">
              {pill}
            </span>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-144">
          <img src="https://cdn.magicpatterns.com/uploads/2tt4wCymyoKLn1UUhHurmY/Mockup_mama_sin_caos.png" alt="S.O.S. Lactancia Pack Mockup" className="w-full h-auto drop-shadow-2xl" data-id="element-145" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="flex flex-col items-center" data-id="element-146">
          <a href="https://www.mamasincaos.store/cart/53013040890153:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto px-8 py-5 bg-brand-accent hover:bg-brand-accent/90 text-brand-darker text-xl md:text-2xl font-bold rounded-xl shadow-[0_0_40px_rgba(143,188,122,0.3)] transition-all hover:scale-105 hover:shadow-[0_0_60px_rgba(143,188,122,0.5)] animate-pulse-slow" data-id="element-147">
            🌿 → QUIERO MI PACK AHORA
          </a>

          <div className="flex flex-wrap justify-center gap-6 mt-6 text-sm text-brand-primary/80" data-id="element-148">
            <span className="flex items-center gap-2" data-id="element-149">
              <ShieldCheck size={16} className="text-brand-gold" data-id="element-150" /> Garantía 7
              días
            </span>
            <span className="flex items-center gap-2" data-id="element-151">
              <Lock size={16} className="text-brand-gold" data-id="element-152" /> Pago seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-153">
              <CreditCard size={16} className="text-brand-gold" data-id="element-154" /> Mercado Pago
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}